'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.608 3a.32.32 0 0 1 .321.321v2.37h14.75c.177 0 .321.144.321.322v14.665a.322.322 0 0 1-.322.322H5.608a2.61 2.61 0 0 1-2.606-2.557C3 18.426 3 18.407 3 18.39V5.61C3 4.172 4.17 3 5.608 3Zm14.75 3.334H5.928v9.767a.32.32 0 0 1-.32.322 1.968 1.968 0 0 0 0 3.934h14.748V6.334ZM9.065 13.275c.177 0 .32.144.32.321v5.754h-.642v-5.432H6.957v-.643h2.109Zm10.285 4.03v.643h-7.688v1.402h-.643v-1.723c0-.178.144-.322.322-.322h8.01ZM5.286 3.671a1.965 1.965 0 0 0-1.643 1.94v11.062c.411-.47.99-.792 1.643-.874Zm6.377 3.67v7.688h7.688v.643h-8.01a.321.321 0 0 1-.32-.321V7.34h.642Zm4.266 4.038c.092 0 .164.025.215.074.05.05.076.12.076.211a.28.28 0 0 1-.077.208.29.29 0 0 1-.214.077c-.094 0-.167-.025-.218-.075a.28.28 0 0 1-.077-.21c0-.094.025-.165.075-.213.05-.048.124-.072.22-.072ZM9.386 7.34v3.98a.32.32 0 0 1-.32.321H6.956v-.643h1.787V7.34h.642Zm6.64 2.081c.23 0 .414.055.55.165a.544.544 0 0 1 .203.442.585.585 0 0 1-.084.318c-.055.09-.161.19-.318.302a.94.94 0 0 0-.203.181.275.275 0 0 0-.043.162v.1h-.443v-.123c0-.108.022-.2.068-.28a.924.924 0 0 1 .25-.253c.119-.083.196-.152.233-.204a.29.29 0 0 0 .056-.176.193.193 0 0 0-.08-.166.39.39 0 0 0-.224-.056c-.168 0-.36.054-.573.164l-.182-.367c.248-.14.512-.209.79-.209Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.306 13.279v.107h.107v.643h-.429a.321.321 0 0 1-.32-.321v-.43h.642Zm4.029.107v.643h-.677v-.643h.677Zm-1.979 0v.643h-.677v-.643h.677Zm3.995-.107v.429a.321.321 0 0 1-.321.32h-.43v-.642h.109v-.107h.642Zm0-1.943v.677h-.643v-.677h.643Zm-6.045 0v.677h-.643v-.677h.643Zm6.045-1.979v.677h-.643v-.677h.643Zm-6.045 0v.677h-.643v-.677h.643Zm5.724-2.016c.177 0 .321.144.321.32v.43h-.643v-.107h-.107V7.34h.43Zm-5.617 0v.643h-.107v.107h-.643v-.43c0-.176.144-.32.322-.32h.428Zm3.922 0v.643h-.677v-.643h.677Zm-1.979 0v.643h-.677v-.643h.677Z",
    fill: "currentColor"
  })));
});
var FwSet0PlotUnknown = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0PlotUnknown = FwSet0PlotUnknown;